import { NotificationEventEnum } from '.'
import { IssueStatus } from '../statuses/issue'
import { NotificationEventItem } from './NotificationEventItem'
import { CommentedNotificationEventItem } from './common/commented'
import { EditedNotificationEventItem } from './common/edited'
import { RevertedNotificationEventItem } from './common/reverted'

const Submitted = new NotificationEventItem({
  id: '1ba4b0b9-2ad3-491b-ba42-21fa7aac3731',
  name: 'Submitted',
  description: `An issue is sent from ${IssueStatus.Draft.name} to ${IssueStatus.PendingResponse.name}`,
})

const Responded = new NotificationEventItem({
  id: '99459204-fd55-4a5a-9f92-e8a7e7e40426',
  name: 'Responded',
  description: `A response is made to an issue, advancing it to ${IssueStatus.PendingDisposition.name}`,
})

const DispositionGiven = new NotificationEventItem({
  id: '6ba1e0ca-d2ed-4bbc-aff3-adb8ae031741',
  name: 'Disposition Given',
  description: `A disposition is submitted for an issue, advancing it to ${IssueStatus.PendingClosure.name}`,
})

const Closed = new NotificationEventItem({
  id: 'a7fead6a-0554-4cff-9bed-b0e2e6889993',
  name: 'Closed',
  description: 'An issue is marked as closed',
})

const Edited = EditedNotificationEventItem({
  id: 'd85227a1-5485-479a-b284-ff206c26e443',
  editable: 'Issue',
})

const Reverted = RevertedNotificationEventItem({
  id: '2299e008-cace-4afe-aaf6-bc0ce6165e01',
  from: [
    IssueStatus.Closed,
    IssueStatus.PendingClosure,
    IssueStatus.PendingDisposition,
    IssueStatus.PendingResponse,
  ],
  to: [
    IssueStatus.PendingClosure,
    IssueStatus.PendingDisposition,
    IssueStatus.PendingResponse,
    IssueStatus.Draft,
  ],
  revertable: 'Issue',
})

const Commented = CommentedNotificationEventItem({
  id: '4f048f10-704d-46c7-8d0d-5dd419b56921',
  commentable: 'Issue',
})

export type IssueNotificationEventItem =
  | typeof Submitted
  | typeof Responded
  | typeof DispositionGiven
  | typeof Closed
  | typeof Edited
  | typeof Reverted
  | typeof Commented

class IssueNotificationEnum extends NotificationEventEnum<
  'IssueNotification',
  IssueNotificationEventItem,
  IssueNotificationEventItem['name'],
  IssueNotificationEventItem['id']
> {
  typename = 'IssueNotification' as const
  get values() {
    return [
      this.Submitted,
      this.Responded,
      this.DispositionGiven,
      this.Closed,
      this.Edited,
      this.Reverted,
      this.Commented,
    ]
  }
  readonly Submitted = Submitted
  readonly Responded = Responded
  readonly DispositionGiven = DispositionGiven
  readonly Closed = Closed
  readonly Edited = Edited
  readonly Reverted = Reverted
  readonly Commented = Commented
}

export const IssueNotificationEvent = new IssueNotificationEnum()
